import store from '../store'
import axios from 'axios'

export default async(missionId, commentId) => {
  let responseData = {}
  responseData.error = false;
  let defaultLanguage = '';
  if (store.state.defaultLanguage !== null) {
    defaultLanguage = (store.state.defaultLanguage).toLowerCase();
  }
  let data = {};
  const url = `${window.cipConfig.VUE_APP_API_ENDPOINT}app/missions/${missionId}/comments/${commentId}/like`
  await axios({
    url: url,
    data,
    method: 'post',
    headers: {
      'X-localization': defaultLanguage,
    }
  }).then((response) => {
    responseData.error = false;
    responseData.message = response.data.message;
  })
    .catch(error => {
      if (error.response.data.errors[0].message) {
        responseData.error = true;
        responseData.message = error.response.data.errors[0].message;
      }
    })
  return responseData;
}
